import {FC} from 'react'
import classNames from 'classnames'

import {IconButton, type IconButtonProps} from '../IconButton/IconButton'
import {PowerIcon} from '../SvgIcon/Endpoints'

export type PowerIconActionButtonProps = Omit<IconButtonProps, 'children'> & {
  powerIconClasses?: string
  powerIconWidth?: number
  powerIconHeight?: number
}

const defaultPowerActionButtonClasses = classNames(
  'w-8 h-8 flex justify-center items-center rounded-full border border-transparent bg-gray-800 text-white transition-colors group mobile:h-11 mobile:w-11',
  'hover:bg-white hover:border-white hover:text-black',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-1 focus-visible:ring-offset-gray-800',
  'disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-gray-800 disabled:hover:border-transparent disabled:hover:text-white',
)

export const PowerIconActionButton: FC<PowerIconActionButtonProps> = ({
  powerIconClasses,
  powerIconWidth = 24,
  powerIconHeight = 24,
  size = 'sm',
  borderRadius = 'full',
  buttonClasses,
  ...iconButtonProps
}) => (
  <IconButton
    size={size}
    borderRadius={borderRadius}
    buttonClasses={classNames(defaultPowerActionButtonClasses, buttonClasses)}
    {...iconButtonProps}
  >
    <PowerIcon
      width={powerIconWidth}
      height={powerIconHeight}
      classes={classNames('group-hover:text-black', powerIconClasses)}
    />
  </IconButton>
)
